export const MAX_DICTATION_DURATION_MS = 10 * 60 * 1000; // 10 minutes
export const MAX_DURATION_WARNING_MS = 60 * 1000; // warning 1 min before max
export const WARNING_START_MS = MAX_DICTATION_DURATION_MS - MAX_DURATION_WARNING_MS; // 9 minutes

// Max-bin value (0–50 scale) above which we consider the mic as having captured real audio.
// A working mic with ambient sound easily exceeds this; a dead/muted mic stays at 0.
export const AUDIO_ACTIVITY_THRESHOLD = 8;
